import React from "react";

// Layout Types
import { DefaultLayout } from "./layouts";

// Route Views
import Dashboard from "./views/Dashboard";
// import UserProfile from "./views/UserProfileLite";
import AddNewPost from "./views/AddNewPost";
import Errors from "./views/Errors";
import Login from "./views/Login";
import ComponentsOverview from "./views/ComponentsOverview";
import Tables from "./views/Tables";
import BlogPosts from "./views/BlogPosts";
import TemplatesList from "./views/Templates/TemplatesList";
import TemplateEdit from "./views/Templates/TemplateEdit";
import NewTemplate from "./views/Templates/NewTemplate";
import UserProfile from "./views/Users/UserProfile";
import ResourcesList from "./views/Resources/ResourcesList";
import NewResource from "./views/Resources/NewResource";
import EditResource from "./views/Resources/EditResource";
import PaymentsList from "./views/Payments/PaymentsList";
import ReferralsList from "./views/Referrals/ReferralsList";
import ReferralDetails from "./views/Referrals/ReferralDetails";
import CouponsList from "./views/Coupons/CouponsList";
import PlansList from "./views/Plans/PlansList";
import NewUserList from "./views/Users/NewUsersList";
import EducationTaxonomy from "./views/Education/EducationTaxonomy";
import LearningStudio from "./views/Education/LearningStudio";

export default [
  {
    path: "/",
    exact: true,
    // layout: DefaultLayout,
    // component: () => <Redirect to="/login" />
    layout: (props) => <DefaultLayout {...props} noSidebar={true} noNavbar={true} noFooter={true} customClass={'loginPage'} />,
    component: Login
  },
  {
    path: "/login",
    exact: true,
    // layout: DefaultLayout,
    layout: (props) => <DefaultLayout {...props} noSidebar={true} noNavbar={true} noFooter={true} customClass={'loginPage'} />,
    component: Login
  },
  {
    path: "/dashboard",
    private: true,
    layout: DefaultLayout,
    component: Dashboard
  },
  {
    path: "/users-list",
    private: true,
    layout: DefaultLayout,
    component: NewUserList
  },
  {
    path: "/user/:_userId",
    private: true,
    layout: DefaultLayout,
    component: UserProfile
  },
  {
    path: "/add-new-post",
    private: true,
    layout: DefaultLayout,
    component: AddNewPost
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors
  },
  {
    path: "/components-overview",
    private: true,
    layout: DefaultLayout,
    component: ComponentsOverview
  },
  {
    path: "/tables",
    private: true,
    layout: DefaultLayout,
    component: Tables
  },
  {
    path: "/templates-list",
    private: true,
    layout: DefaultLayout,
    component: TemplatesList
  },
  {
    path: "/new-template",
    private: true,
    layout: DefaultLayout,
    component: NewTemplate
  },
  {
    path: "/education-taxonomy",
    private: true,
    layout: DefaultLayout,
    component: EducationTaxonomy
  },
  { path: "/learning-studio", private: true, layout: DefaultLayout, component: LearningStudio },
  {
    path: "/resources-list",
    private: true,
    layout: DefaultLayout,
    component: ResourcesList
  },
  {
    path: "/new-resource",
    private: true,
    layout: DefaultLayout,
    component: NewResource
  },
  {
    path: "/resource/:_resourceId/edit",
    private: true,
    layout: DefaultLayout,
    component: EditResource
  },
  {
    path: '/template/:_templateId/edit',
    private: true,
    layout: DefaultLayout,
    component: TemplateEdit
  },
  {
    path: "/blog-posts",
    private: true,
    layout: DefaultLayout,
    component: BlogPosts
  },
  {
    path: "/payments-list",
    private: true,
    layout: DefaultLayout,
    component: PaymentsList
  },
  {
    path: "/referrals",
    private: true,
    layout: DefaultLayout,
    component: ReferralsList
  },
  {
    path: '/referral/:_referralId',
    private: true,
    layout: DefaultLayout,
    component: ReferralDetails
  },
  {
    path: "/coupons",
    private: true,
    layout: DefaultLayout,
    component: CouponsList
  },
  {
    path: "/plans",
    private: true,
    layout: DefaultLayout,
    component: PlansList
  },
];
